var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGyo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 60",
    style: {
      enableBackground: "new 0 0 120 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9,32.2h14.8v1.9c0,8.2-6.8,14.2-15.2,14.2c-11.3,0-17-8.3-17-18.3c0-10,6.2-18.3,16.9-18.3c7.9,0,13.5,4.5,14.8,11.4 h1.1c-1.2-7.5-7.3-12.4-15.9-12.4c-11.3,0-18,8.5-18,19.3c0,10.6,6.1,19.3,18,19.3c7.5,0,13.3-3.8,15.3-10h0.1v9.2h1.1V31.2H21.9 V32.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.3,30.1 44.6,10.7 43.3,10.7 58.8,31.2 58.8,49.3 59.8,49.3 59.8,31.2 59.8,31.2 75.3,10.7 74,10.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,10.7c-11.5,0-17.6,8.8-17.6,19.3s6.2,19.3,17.6,19.3s17.6-8.8,17.6-19.3S109,10.7,97.5,10.7z M97.5,48.3 C87.3,48.3,81.1,40.6,81,30c0.1-10.6,6.3-18.3,16.6-18.3S114,19.4,114.1,30C114,40.6,107.8,48.3,97.5,48.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGyo);
export default __webpack_public_path__ + "static/media/logo-gyo.d5e02694e8a495f3ae96e87af2aee476.svg";
export { ForwardRef as ReactComponent };